import { TemplateFormFactory } from '../../template-form/factories/templateFormFactory';
import {
  EntityDefaultName,
  TemplateRawForm
} from '../../template-form/interfaces/template-raw-form';
import { TemplateForm, TemplateFormMode } from '../../template-form/interfaces/template-form';
import { EntityFormMetaData, EntityFormType } from '../interfaces/entity-form';
import { EntityNameFieldFactory } from './entityNameFieldFactory';

export function EntityFormFactory(
  rawForm: TemplateRawForm,
  entity: EntityFormType,
  mode: TemplateFormMode,
  metaData?: { [key: string]: unknown } | null
): TemplateForm<EntityFormMetaData> {
  const rawFormWithNameField = EntityNameFieldFactory(
    rawForm,
    entity,
    mode,
    (metaData?.entityDefaultName as EntityDefaultName)?.entity_name ?? null
  );

  const formTemplate = TemplateFormFactory(rawFormWithNameField, mode);

  const formMetaData = {
    canRenderSBSDocs: !!rawForm.template.entity_type.doc_link,
    docLink: rawForm.template.entity_type.doc_link,
    isEditable: true,
    logo: rawForm.template.entity_type.logo_url,
    logoDarkMode: rawForm.template.entity_type.logo_url
  };

  return {
    ...formTemplate,
    metadata: {
      ...formTemplate.metadata,
      ...formMetaData
    }
  };
}
